import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from "react-select";
import ReactDatatable from "@ashvin27/react-datatable";

const ViewPlanModal = (props) => {
    const {responsive, configdata12, PlanShowTable, columnsPlansTable, pageChange} = props

    const [showModel, setShowModel] = useState(true)

    return (
        <div className='modals'>
            <Modal
                onHide={() => { props.onDismiss() }}
                show={showModel}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header closeButton onClick={() => props.onDismiss()}>
                    <Modal.Title>
                        Plans
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div className="">
                        <div className="w-100 themetable">
                          <ReactDatatable
                            responsive={responsive}
                            className="table table-striped table-responsive react_table_border_align themetable"
                            config={configdata12}
                            records={PlanShowTable}
                            columns={columnsPlansTable}
                            onPageChange={pageChange()}
                          />
                        </div>

                      </div>
                </Modal.Body>

            </Modal>

        </div>
    )
}

export default ViewPlanModal